import { Tooltip, Avatar as AntAvatar } from 'antd';
import React from 'react';
import { User } from 'api/models';
import { Avatar, AvatarGroup } from 'components/atoms/avatar';
import { getUserFullName } from 'components/organisms/customer-portfolio/org-chart/components/OrgNode';

interface Props {
  participants: Pick<User, 'firstName' | 'lastName' | 'emailId' | 'photoUrl'>[];
  maxParticipants?: number;
}

export const MeetingsParticipants = ({
  participants,
  maxParticipants = 3,
}: Props) => {
  const filteredParticipants = participants.slice(
    0,
    participants.length > maxParticipants
      ? maxParticipants - 1
      : participants.length,
  );
  const getTooltipContent = () => {
    if (participants.length <= maxParticipants) {
      return '';
    }

    return (
      <>
        {participants.map((user) => (
          <>
            {user.firstName ? getUserFullName(user) : user.emailId}
            <br />
          </>
        ))}
      </>
    );
  };

  return (
    <AvatarGroup>
      {filteredParticipants.map((participant) => (
        <Avatar
          key={participant.emailId}
          name={getUserFullName(participant) ?? participant.emailId}
          src={participant.photoUrl}
          size="small"
        />
      ))}
      {participants.length > maxParticipants ? (
        <Tooltip title={getTooltipContent} trigger="hover" placement="top">
          <AntAvatar key="more">{`+${
            participants.length - maxParticipants + 1
          }`}</AntAvatar>
        </Tooltip>
      ) : null}
    </AvatarGroup>
  );
};
